import { CUSTOMER_COMP } from './../customer.const';
import { Component, OnInit } from '@angular/core';
import store from './../../../store/store.module';
import { CREATE_CUSTOMER_REQUESTED } from './create.actions';
import * as _ from 'lodash';
import { CREATE_CUSTOMER_ADDRESS_REQUESTED, FETCH_CUSTOMER_ADDRESSES_REQUESTED } from '../edit/edit.actions';
import { FETCH_ALL_CUSTOMER_GROUP_REQUESTED } from '../customer.actions';
import {UtilityService} from "../../../common/services/utility/utility.service";
import {USER_COMP} from "../../user/user.const";
import {COLLECTION_CREATE_COMP} from "../../collection/collection.const";

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {
  public store = store;

  public addNewAdd = false;
  public filter;

  public customer = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    gender: '',
    group: '',
    default_address_id: null,
    role_id: 2,
    type: 'VIP',
    password: '',
    re_password: '',
    whitegloveverify: ''
  };
  public disabledField = [];
  public redirectData;
  constructor(private utilityService: UtilityService) {
    store.dispatch({
      type: FETCH_ALL_CUSTOMER_GROUP_REQUESTED,
      com: CUSTOMER_COMP
    });
  }

  ngOnInit() {
    this.redirectData = this.utilityService.getRedirectData();
    if (this.redirectData.defaultValue) {
      this.customer = Object.keys(this.redirectData.defaultValue).reduce((prevValue, currentValue) => {
        prevValue[currentValue] = this.redirectData.defaultValue[currentValue];
        return prevValue;
      }, this.customer);
    }
    if (this.redirectData.com === COLLECTION_CREATE_COMP) {
      this.disabledField.push('password');
      this.disabledField.push('re_password');
    }
  }

  onSubmit(form) {
    if (form.valid) {
      store.dispatch({
        type: CREATE_CUSTOMER_REQUESTED,
        data: _.assign({}, this.customer),
        com: this.redirectData.com ? this.redirectData.com : CUSTOMER_COMP,
        redirect: this.redirectData.page
      });
    }
  }

  openNewAddressForm() {
    this.addNewAdd = !this.addNewAdd;
  }
}
